export const environment = {
  production: false,
  apiUrl: 'https://schedulerapidev.cordelllaw.com',
  appointmentBufferHours: 72
};
